// extracted by mini-css-extract-plugin
export default {"carousel__wrapper":"kx","carousel__wrapper_on_sides":"lx","arrows_wrapper":"mx","arrows_wrapper_right":"nx","arrows_wrapper_vertical":"ox","arrows_wrapper_on_sides":"px","arrow_button":"qx","carousel_arrow_left":"rx","carousel_arrow_left_on_side":"sx","carousel_arrow_right_on_side":"tx","carousel_arrow":"ux","arrows_wrapper_rounded":"vx","carousel__fullWidth":"wx"};
    if(module.hot) {
      // 1711717533245
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  